/**
 * Pure context → per-turn `turnMetadata`. Watching (has `catalogId`):
 * `{ catalogId, videoTimestampSeconds }` plus `lessonId`/`trackId` when present;
 * otherwise `{}` — which callers must treat as "send no option at all" so
 * un-migrated consumers are unaffected.
 *
 * `catalogId` is the required anchor: the backend derives `content_id` from it
 * and returns `<no_viewing_context/>` when it's absent, so `lessonId`/`trackId`
 * are only ever meaningful alongside a video and are layered on top here.
 */
export const buildTurnMetadata = context => {
  var _context$videoTimesta;
  if (context.catalogId == null || context.catalogId === '') {
    return {};
  }
  const turnMetadata = {
    catalogId: context.catalogId,
    videoTimestampSeconds: String((_context$videoTimesta = context.videoTimestampSeconds) !== null && _context$videoTimesta !== void 0 ? _context$videoTimesta : 0)
  };
  if (context.lessonId) {
    turnMetadata.lessonId = context.lessonId;
  }
  if (context.trackId) {
    turnMetadata.trackId = context.trackId;
  }
  return turnMetadata;
};